import { meetingsFromSaved } from './meetings';
import { PROGRAMS } from './CreateApplicationSection2';
import { getDefaultCourseContext } from './CreateApplicationSection4';
import { programResponsesFromSaved } from './CreateApplicationSection5';

// Where a saved draft opens: the create wizard, filled from the draft
export const resumeDraftPath = (id) => `/applications/new?draft=${id}`;

// A CRN check answer naming another of the applicant's own drafts. Drafts
// claim nothing (only a submitted application holds a CRN for a term), so
// such a match informs but never blocks. The wizard's block and Section 1's
// note both read this one predicate so they cannot disagree.
export const isOwnDraftMatch = (result) =>
    !!result?.own && result.status === 'draft';

// A saved ranking as the wizard's Program Selection state, first choice
// first, ranks renumbered so a gap left by a removed program can't persist
export function selectedProgramsFromSaved(programPreferences) {
    return [...(programPreferences || [])]
        .sort((a, b) => a.rank - b.rank)
        .map((pref) => PROGRAMS.find((p) => p.key === pref.programType))
        .filter(Boolean)
        .map((program, i) => ({ ...program, rank: i + 1 }));
}

/**
 * A saved draft as the create wizard's state, so resuming shows every answer
 * as it was saved.
 *
 * The Review & Submit confirmation is the one answer not restored: it
 * attests to the answers as they stood when it was given, and the server
 * clears it for the same reason when an application is returned for
 * revision, so it is given again before submitting.
 */
export function getResumeSeed(app) {
    const saved = app.courseConfirmation || {};
    return {
        isSubmittedOnBehalf: app.isSubmittedOnBehalf === true,
        courseConfirmation: {
            crn: saved.crn || '',
            enrollment: saved.enrollment ?? '',
            sectionNumber: saved.sectionNumber || '',
            partOfTermCode: saved.partOfTermCode || '',
            partOfTermName: saved.partOfTermName || '',
            instructorOfRecordName: saved.instructorOfRecordName || '',
            instructorOfRecordEmail: saved.instructorOfRecordEmail || '',
            modality: saved.modality || '',
            otherModality: saved.otherModality || '',
            meetings: meetingsFromSaved(saved),
        },
        courseContext: {
            ...getDefaultCourseContext(),
            ...(app.courseContext || {}),
        },
        programResponses: programResponsesFromSaved(
            app.programSpecificResponses
        ),
        selectedPrograms: selectedProgramsFromSaved(app.programPreferences),
        namedStudents: (app.namedStudents || []).map((s) => ({
            name: s.name || '',
            email: s.email || '',
            studentId: s.studentId || '',
            forProgram: s.forProgram,
        })),
        acknowledgesGeneralTerms: app.acknowledgesGeneralTerms === true,
    };
}
